<template>
  <v-container fluid>

    <v-row justify="center">
      <v-col cols="12">
        <h1>{{$t("message.admin.sendmail.title.send")}}</h1>
      </v-col>
    </v-row>

    <!-- エラー -->
    <v-row justify="center" v-if="view.errors.length > 0">
      <v-col cols="12">
        <mp-error :errors="view.errors" :replaceList="errMessageReplaceList" message-key="message.admin.sendmail.error." />
      </v-col>
    </v-row>

    <v-row justify="end">
      <v-col cols="12" class="text-right">
        <span class="red--text">※</span>は必須項目です
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.from")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col>
          <v-select
            v-model="form.from"
            :items="view.fromAddressList"
            :label="$t('message.admin.sendmail.ph.from')"
            id="from"
            hide-details
            dense
            solo
          ></v-select>
      </v-col>
    </v-row>

    <v-row justify="center">
      <!-- 宛先（To） -->
      <v-col cols="2" class="pb-0">
        <mp-label class="pt-0"></mp-label>
      </v-col>

      <!-- 利用サービス -->
      <v-col cols="2">
        <mp-label>{{$t("message.admin.sendmail.label.services")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col>
          <v-select
            v-model="form.services"
            :items="view.serviceList"
            item-text="serviceName.ja"
            item-value="serviceId"
            :label="$t('message.admin.sendmail.ph.services')"
            id="serviceId"
            hide-details
            dense
            solo
            multiple
            chips
          ></v-select>
      </v-col>
    </v-row>

    <!-- 所属 -->
    <v-row justify="center">
      <v-col cols="2" class="py-0">
        <mp-label class="pt-0">{{$t("message.admin.sendmail.label.to")}}<span class="red--text">※</span></mp-label>
      </v-col>

      <v-col cols="2">
        <mp-label>{{$t("message.admin.sendmail.label.group")}}</mp-label>
      </v-col>
      <v-col>
        <v-row v-for="(item, index) in getGroupList"
          :key="item.groupLargeId"
        >

          <v-col class="pa-1 pl-3">
            <v-radio-group v-model="form.groupLargeId" class="mt-0">
              <v-radio
                :label="item.groupLargeName.ja"
                :value="item.groupLargeId"
                :id="`groupLargeId-${item.groupLargeId}`"
                hide-details
                dense
                @change="changeGroupLarge(item.groupLargeId, item.companyInsNoFlg)"
              />
            </v-radio-group>
          </v-col>
          <v-col class="py-1 pr-3">
            <v-select v-show="item.groupLargeId > 0"
              v-model="form.groupSmallId"
              :items="view.groupList[index].groupSmallList"
              :label="$t('message.admin.sendmail.ph.groupSmall')"
              :item-text="getGroupSmallName"
              item-value="groupSmallId"
              :id="`groupSmallId-${item.groupLargeId}`"
              hide-details
              solo
              dense
              multiple
              chips
              :disabled="form.groupLargeId !== item.groupLargeId"
              @change="changeGroupSmall(form.groupSmallId, item.companyInsNoFlg)"
            ></v-select>
          </v-col>

        </v-row>
      </v-col>
    </v-row>

    <!-- 会社 -->
    <v-row justify="center">
      <v-col cols="2" class="py-0">
        <mp-label></mp-label>
      </v-col>

      <v-col cols="2">
        <mp-label>{{view.companyLabel.ja}}</mp-label>
      </v-col>
      <v-col>
          <v-select
            v-model="form.companyId"
            :items="view.companyList"
            :label="$t('message.admin.sendmail.ph.companyId')"
            item-text="companyName"
            item-value="companyId"
            :disabled="view.companyList.length === 0 || view.groupList.find(item => form.groupLargeId === item.groupLargeId).companyInsNoFlg === '1'"
            id="companyId"
            hide-details
            solo
            dense
            multiple
            chips
          ></v-select>
      </v-col>
    </v-row>

    <!-- 都道府県 -->
    <v-row justify="center">
      <v-col cols="2" class="pt-0">
        <mp-label></mp-label>
      </v-col>

      <v-col cols="2">
        <mp-label>{{$t("message.admin.sendmail.label.prefCd")}}</mp-label>
      </v-col>
      <v-col>
          <v-select
            v-model="form.prefCd"
            :items="$store.getters.prefCodeList"
            :item-text="getPrefName"
            item-value="kbnCd"
            :label="$t('message.admin.sendmail.ph.prefCd')"
            id="prefCd"
            hide-details
            dense
            solo
            multiple
            chips
          ></v-select>
      </v-col>
    </v-row>

    <!-- 宛先確認ボタン -->
    <v-row justify="end">
      <v-col cols="3">
        <mp-button wide @click="goSearch">{{ $t('message.admin.sendmail.button.showAddress') }}</mp-button>
        <form-list :show="dialog.sendMailList" :optionForm="form"
            @clickCancel="dialog.sendMailList = false"/>
      </v-col>
    </v-row>

    <!-- 宛先（Cc） -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.cc")}}</mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.cc"
          v-bind:placeholder="$t('message.admin.sendmail.ph.cc')"
          id="cc"
          hide-details
          dense
          solo
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 件名 -->
    <v-row justify="center">
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.subject")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-text-field
          v-model="form.subject"
          v-bind:placeholder="$t('message.admin.sendmail.ph.subject')"
          id="subject"
          hide-details
          solo
          maxlength="100"
          required
          validate-on-blur
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- 本文 -->
    <v-row justify="center" >
      <v-col cols="4">
        <mp-label>{{$t("message.admin.sendmail.label.body")}}<span class="red--text">※</span></mp-label>
      </v-col>
      <v-col cols="8">
        <v-textarea
          v-model="form.body"
          v-bind:placeholder="$t('message.admin.sendmail.ph.body')"
          id="body"
          hide-details
          solo
          maxlength="20000"
          height="500"
        ></v-textarea>
      </v-col>
    </v-row>

    <!-- 埋め込み文字列説明 -->
    <v-row justify="center">
      <v-col cols="4" class="pt-0"></v-col>
      <v-col class="pt-0">
        <div>
          {{ $t('message.admin.sendmail.desc.send.text1') }}
        </div>
        <div>
          {{ $t('message.admin.sendmail.desc.send.text2') }}
        </div>
        <div>
          {{ $t('message.admin.sendmail.desc.send.text3') }}
        </div>
      </v-col>
    </v-row>

    <!-- 送信ボタン -->
    <v-row justify="center">
      <v-col
        class="text-center"
        cols="6"
        md="3"
      >
        <mp-button wide @click="beforeSend">{{ $t('message.admin.sendmail.button.send') }}</mp-button>
        <form-confirm :show="dialog.inputConfirm" :optionForm="form"
            :service="view.serviceList" :group="view.groupList" :company="view.companyList"
            :companyLabel="view.companyLabel" :prefCd="form.prefCd"
            @clickOk="goSend" @clickCancel="dialog.inputConfirm = false"/>
        <mp-dialog sendmail :show="dialog.sendMailComplete" @clickOk="goTop" />
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
// import i18n from '@/message'
import MpLabel from '@/components/item/MpLabel.vue'
import MpButton from '@/components/item/MpButton.vue'
import MpDialog from '@/components/item/MpDialog.vue'
import { AdminSendMail, Common } from '@/api'
import constantValue from '@/constantValue'
import MpError from '@/components/item/MpError'
import FormList from './ListDialog.vue'
import FormConfirm from './SendConfirm.vue'
import StringUtils from '@/utils/StringUtil'

export default {
  name: 'AdminSendMailSend',
  components: {
    MpError,
    MpLabel,
    MpButton,
    FormList,
    FormConfirm,
    MpDialog
  },
  data: () => ({
    constantValue: constantValue,
    view: {
      fromAddressList: [],
      serviceList: [],
      companyInsNoFlg: '',
      companyDefaultLabel: {
        ja: ''
      },
      companyLabel: {
        ja: ''
      },
      groupList: [],
      companyList: [],
      errors: []
    },
    form: {
      from: '',
      services: [],
      groupLargeId: '',
      groupSmallId: [],
      companyId: [],
      prefCd: [],
      cc: '',
      subject: '',
      body: ''
    },
    dialog: {
      sendMailList: false,
      inputConfirm: false,
      sendMailComplete: false
    },
    errMessageReplaceList: []
  }),
  computed: {
    getGroupList () {
      return this.view.groupList
    }
  },
  methods: {
    initCompanyList () {
      this.view.companyList = []
      this.form.companyId = []
    },
    initCompanyLabel () {
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
    },
    changeGroupLarge (groupLargeId, companyInsNoFlg) {
      // 会社および支社・支局または媒体を初期化
      this.initCompanyList()
      this.initCompanyLabel()

      this.view.companyInsNoFlg = companyInsNoFlg
      this.form.groupSmallId = []
    },
    changeGroupSmall (groupSmallIds, companyInsNoFlg) {
      // 会社および支社・支局または媒体を初期化
      this.initCompanyList()
      this.setCompanyLabel(groupSmallIds)

      // 会社情報を設定
      if (companyInsNoFlg === '0') {
        this.getCompanyList(groupSmallIds)
      }
    },
    setCompanyLabel (groupSmallIds) {
      const groupSmall = this.view.groupList
        .flatMap(groupLarge => groupLarge.groupSmallList)
        .filter(groupSmall => groupSmallIds.includes(groupSmall.groupSmallId))

      if (groupSmall.length === 0) {
        this.view.companyLabel.ja = this.view.companyDefaultLabel.ja
      } else {
        const res = []
        for (const grpSmall of groupSmall) {
          const lbl = StringUtils.isEmpty(grpSmall.companyLabel.ja) ? this.view.companyDefaultLabel.ja : grpSmall.companyLabel.ja
          if (!res.includes(lbl)) {
            res.push(lbl)
          }
        }
        this.view.companyLabel.ja = res.join(',')
      }
    },
    getGroupSmallName (item) {
      return item.groupSmallName.ja
    },
    getPrefName (item) {
      return item.kbnVal.ja
    },
    async getCompanyList (groupSmallIds) {
      // 返却用のリスト準備
      for (const grpSmallId of groupSmallIds) {
        const comapnys = await Common.companyList({ groupSmallId: grpSmallId })
        this.view.companyList = this.view.companyList.concat(comapnys)
      }
    },
    goSearch () {
      this.dialog.sendMailList = true
      this.view.errors = []
    },
    goTop () {
      this.$router.push({ path: '/' })
    },
    async beforeSend () {
      if (this.form.from !== '') {
        // 入力内容確認ダイアログを表示
        this.dialog.inputConfirm = true
        return
      }
      this.view.errors = []
      await this.goSend() // APIコールへ
    },
    async goSend () {
      this.dialog.inputConfirm = false
      await AdminSendMail.send({ ...this.form })
        .then(() => {
          this.dialog.sendMailComplete = true
        })
        .catch(error => { this.view.errors = error.messages })
    },
    async setDefaultLabel () {
      const list = await Common.labelList({ key: 'default' })
      this.view.companyLabel.ja = this.view.companyDefaultLabel.ja = this.getDefaultLabelFromList(list, 'label.default.company.ja')
    },
    getDefaultLabelFromList (list, key) {
      const ele = list.find(ele => ele.configKey === key)
      if (ele === undefined || ele.configVal === undefined) {
        return ''
      }
      return ele.configVal
    },
    setErrMessageReplaceList () {
      this.errMessageReplaceList = [
        { param: 'companyId', pattern: '##COMPANY_LABEL##', replacement: this.view.companyLabel }
      ]
    }
  },
  created: async function () {
    this.view.constantValue = constantValue
    this.view.fromAddressList = await Common.fromAddressList()
    this.view.serviceList = (await Common.serviceList())

    this.view.groupList = await Common.groupList()
    this.view.groupList.unshift(
      {
        groupLargeId: 0,
        groupLargeName:
          {
            ja: 'すべて',
            en: null
          },
        companyInsNoFlg: '1',
        displayOrder: 0,
        groupSmallList: []
      })
    this.form.groupLargeId = 0

    await this.setDefaultLabel()
    this.setErrMessageReplaceList()
  }
}
</script>

<style scoped>
.v-messages {
  min-height: 0px !important;
}
</style>
